<template>
  <div class="flex flex-col flex-grow">
    <Loading class="flex-grow" :loading="waitPending">
      <div class="flex-grow">
        <Table
          :columns="columns"
          :rows="objects"
          :row-style-class="() => 'cursor-pointer'"
          :busy="waitPending"
          @on-row-click="onRowClick"
          @on-sort-change="($event) => {orderBy = $event}"/>
      </div>
    </Loading>
    <div class="flex flex-row items-end justify-center p-6">
      <Pagination
        :page="page"
        :page-count="pageCount"
        @change="onPageChange"/>
    </div>
  </div>
</template>

<script type="text/jsx">
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import Table from '@/components/Table.vue';
import Pagination from '@/components/Pagination.vue';
import Loading from '@/components/Loading.vue';

export default {
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
  },
  components: {
    Table,
    Pagination,
    Loading,
  },
  data() {
    return {
      limit: 100,
      page: 1,
      orderBy: [],
    };
  },
  computed: {
    ...mapGetters({
      payload: 'customers/objects',
    }),
    columns() {
      return [
        {
          label: '№',
          field: 'id',
          tdClass: 'align-middle',
          sortable: true,
        },
        {
          label: 'Создан',
          field: 'createdAt',
          tdClass: 'align-middle',
          cell: ({ row }) => <b>
            { this.$moment(row.createdAt, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY') }
          </b>,
          sortable: true,
        },
        {
          label: 'Регион',
          field: 'regionName',
          tdClass: 'align-middle',
          cell: ({ row }) => <div>{ _.get(row, 'cemetery.district.region.name') }</div>,
          sortable: true,
        },
        {
          label: 'Город',
          field: 'districtName',
          tdClass: 'align-middle',
          cell: ({ row }) => <div>{ _.get(row, 'cemetery.district.name') }</div>,
          sortable: true,
        },
        {
          label: 'Кладбище',
          field: 'cemeteryName',
          tdClass: 'align-middle',
          cell: ({ row }) => <div>{ _.get(row, 'cemetery.name') }</div>,
          sortable: true,
        },
        {
          label: 'Тип объекта',
          field: 'celebrity',
          tdClass: 'align-middle',
          cell: ({ row }) => {
            const celebrity = !!_.get(row, 'celebrity');
            if (celebrity) {
              return <div>Знаменитость</div>;
            }
            return <div>Частный</div>;
          },
          sortable: true,
        },
      ];
    },
    objects() {
      return _.get(this.payload(this.id), 'data') || [];
    },
    offset() {
      return (this.page - 1) * this.limit;
    },
    total() {
      return _.get(this.payload(this.id), 'total') || 0;
    },
    pageCount() {
      return Math.ceil(this.total / this.limit);
    },
    waitKey() {
      return `fetch.customer.objects.${this.id}`;
    },
    waitPending() {
      return this.$wait.is(this.waitKey);
    },
  },
  methods: {
    ...mapActions({
      fetch: 'customers/ACT_FETCH_CUSTOMER_OBJECTS',
    }),
    fetchPayload() {
      let { orderBy } = this;
      if (_.isEqual(orderBy, [])) {
        orderBy = [
          { column: 'id', descending: 1 },
        ];
      }
      this.fetch({
        id: this.id,
        limit: this.limit,
        offset: this.offset,
        orderBy,
      });
    },
    onPageChange(event) {
      this.page = event;
    },
    onRowClick({ row: event }) {
      this.$router.push({
        name: 'objects.details',
        params: {
          id: event.id,
        },
      });
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      this.fetchPayload();
    });
    this.$watch((that) => [that.page, that.orderBy], () => {
      this.fetchPayload();
    });
  },
};
</script>
